import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { GaAuthState } from '../models/index';
import { Observable } from 'rxjs';
import { map, tap, filter, switchMap, take } from 'rxjs/operators';
import { WINDOW, WindowWrapper } from '../../common/index';
import { GaSessionService } from '../services/session.service';
import { GaSessionConfigService } from './../services/session.config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(WINDOW) private window: WindowWrapper,
    private router: Router,
    private sessionConfig: GaSessionConfigService,
    private sessionService: GaSessionService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!this.sessionConfig.enabled) { return true; }
    return this.sessionService.state$.pipe(
      filter(s => s !== GaAuthState.Progress),
      switchMap(() => this.sessionService.sessionUser$),
      take(1),
      map(user => !!(user && user.id))
    );
  }
}
